























































import Vue from 'vue';

export default Vue.extend<any, any, any, any>({
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      zipCodesText: '',
    };
  },
  mounted() {
    // init textarea with prop value
    if (this.value && this.value.length > 0) {
      this.zipCodesText = this.value.join('\n');
    }
  },
  methods: {
    parseZipCodes() {
      if (!this.zipCodesText.trim()) return [];

      return this.zipCodesText
        .split('\n')
        .map((code) => code.trim())
        .filter((code) => code.length > 0)
        .filter((code, index, array) => array.indexOf(code) === index); // remove duplicates
    },
    isValidUSZipCode(zipCode) {
      // US ZIP code patterns: 12345 or 12345-6789
      const usZipPattern = /^(\d{5})(-\d{4})?$/;
      return usZipPattern.test(zipCode);
    },
    isValidCanadianPostalCode(postalCode) {
      // canadian postal code patterns: A1A 1A1 or A1A1A1 (case insensitive)
      // remove all spaces and convert to uppercase for validation
      const normalized = postalCode.replace(/\s/g, '').toUpperCase();

      // must be exactly 6 characters after removing spaces
      if (normalized.length !== 6) return false;

      // pattern: Letter-Digit-Letter-Digit-Letter-Digit
      const canadianPostalPattern = /^[A-Z]\d[A-Z]\d[A-Z]\d$/;
      return canadianPostalPattern.test(normalized);
    },
    isValidPostalCode(code) {
      return (
        this.isValidUSZipCode(code) || this.isValidCanadianPostalCode(code)
      );
    },
  },
  computed: {
    allCodes() {
      if (!this.zipCodesText.trim()) return [];

      return this.zipCodesText
        .split('\n')
        .map((code) => code.trim())
        .filter((code) => code.length > 0);
    },
    validCodes() {
      return this.allCodes.filter((code) => this.isValidPostalCode(code));
    },
    invalidCodes() {
      return this.allCodes.filter((code) => !this.isValidPostalCode(code));
    },
    hasValidationErrors() {
      return this.invalidCodes.length > 0;
    },
    validationErrors() {
      if (this.invalidCodes.length === 0) return [];

      const maxToShow = 3;
      const codes = this.invalidCodes.slice(0, maxToShow);
      const hasMore = this.invalidCodes.length > maxToShow;

      let message = `Invalid postal code${
        this.invalidCodes.length !== 1 ? 's' : ''
      }: ${codes.join(', ')}`;
      if (hasMore) {
        message += ` and ${this.invalidCodes.length - maxToShow} more`;
      }
      message +=
        '. Use US format (12345 or 12345-6789) or Canadian format (A1A 1A1).';

      return [message];
    },
  },
  watch: {
    zipCodesText() {
      // emit the parsed zip codes array whenever text changes
      const parsedCodes = this.parseZipCodes();
      this.$emit('input', parsedCodes);
    },
    value(newVal) {
      // update textarea when prop changes (for edit mode)
      if (newVal && newVal.length > 0) {
        this.zipCodesText = newVal.join('\n');
      } else {
        this.zipCodesText = '';
      }
    },
  },
});
